import { fetcher } from '#lib/backendFetcher';

/**
 * Imports companies from CSV data into a new search query.
 * @param {string} queryName - Name for the new search query
 * @param {Object} columnMapping - Mapping of target fields to CSV column headers
 * @param {Array<Object>} companies - Array of company data from the CSV file
 * @returns {Promise<{success: boolean, prospectQueryId: string, imported: number, skipped: number, errors: Array}>}
 */
export const importCompaniesFromCSV = (queryName, columnMapping, companies) =>
	fetcher('/api/v1/leads/import', {
		method: 'POST',
		body: { queryName, columnMapping, companies },
	});
